<div class="app-container" [class.authenticated]="isAuthenticated">
    <!-- Sidebar - Only show when authenticated -->
    <nav *ngIf="isAuthenticated" class="sidebar">
        <div class="logo">
            <a [routerLink]="['/']" aria-label="CashMe Home">
                <img src="assets/images/cashme-logo.png" alt="CashMe" class="logo-img" />
            </a>
        </div>

        <div class="nav-items">
            <div *ngFor="let item of navigation">
                <!-- Simple link -->
                <div *ngIf="item.url && !item.children" class="nav-item" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="item.url" class="nav-link">
                        <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
                        <span class="nav-text">{{ item.title }}</span>
                    </a>
                </div>

                <!-- Group with children -->
                <div *ngIf="item.children" class="nav-group">
                    <div class="nav-group-title">
                        <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
                        <span class="nav-text">{{ item.title }}</span>
                    </div>

                    <div class="nav-group-items">
                        <a *ngFor="let child of item.children" [routerLink]="child.url" routerLinkActive="active"
                            class="nav-sublink">
                            <span class="nav-subtext">{{ child.title }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content" [class.full-width]="!isAuthenticated">
        <!-- Top bar with profile menu -->
        <div *ngIf="isAuthenticated" class="topbar" [class.on-profile]="isProfileRoute">
            <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User menu" class="profile-button">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu">
                <button mat-menu-item [routerLink]="['/profile']">
                    <mat-icon>person</mat-icon>
                    <span>Profilo</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        </div>

        <router-outlet></router-outlet>
    </main>
</div>